import { render, staticRenderFns } from "./GrupeDelova.vue?vue&type=template&id=afb881dc&scoped=true&"
import script from "./GrupeDelova.vue?vue&type=script&lang=ts&"
export * from "./GrupeDelova.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb881dc",
  null
  
)

export default component.exports